import { IComponentOptions } from "angular";
import { ContractInstanceNumbersComponentController } from "./controller";

export const vsComponentName = "contractInstanceNumbers";

export const contractInstanceNumbersComponentOptions: IComponentOptions = {
  controller: ContractInstanceNumbersComponentController,
  controllerAs: "numbersController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
  },
};
